module.exports = __webpack_public_path__ + "img/transfer15.831865f6.jpeg";